export default {
    props: {
        depot: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        afficheAideCreation() {
            return !this.depot;
        },
    },
}
